/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { useAppDispatch } from 'src/redux';

import { Box, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { TextButton } from 'src/components';

import { loginReferrer } from 'src/redux/referFriend';

import { useLoadGsiScript } from 'src/hooks';

import { OAuthSettings } from 'src/constants';

export const InternalSignIn: React.FC<{ onOtherOptionsClick: () => void }> = ({
  onOtherOptionsClick,
}) => {
  const dispatch = useAppDispatch();

  useLoadGsiScript();

  const handleGAuthCallback = (response: any) => {
    dispatch(loginReferrer({ googleToken: response.credential }));
  };

  // data-callback value must be globally scoped function
  useEffect(() => {
    (window as any).handleGAuthCallback = handleGAuthCallback;

    return () => {
      delete (window as any).handleGAuthCallback;
    };
  }, []);

  return (
    <Stack gap={1}>
      <Typography
        variant="body1"
        color="text.secondary"
        gutterBottom
        sx={{
          marginTop: '32px',
          textAlign: 'center',
          marginBottom: '0',
        }}
      >
        Continue with your AgileEngine email
      </Typography>
      <Box display="flex" justifyContent="center" mb={3}>
        <div
          id="g_id_onload"
          data-client_id={
            process.env.REACT_APP_ENV
              ? OAuthSettings[process.env.REACT_APP_ENV]
              : OAuthSettings.production
          }
          data-context="signin"
          data-ux_mode="popup"
          data-callback="handleGAuthCallback"
          data-auto_prompt="false"
        ></div>

        <div
          className="g_id_signin"
          data-type="standard"
          data-shape="pill"
          data-theme="filled_blue"
          data-text="signin_with"
          data-size="large"
          data-locale="en-US"
          data-logo_alignment="left"
        ></div>
      </Box>
      <TextButton
        variant="secondary"
        onClick={onOtherOptionsClick}
        startIcon={
          <ArrowBackIcon sx={{ color: '#FFB74D', fontSize: '16px' }} />
        }
      >
        Other options
      </TextButton>
    </Stack>
  );
};
